import React from "react";
import {withRouter} from "react-router-dom";
import DashboardVirtualStagingModal from "../virtual_staging/dashboard_virtual_staging_modal";


class NewProjectsDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { vsModalOpen: false }
  }

  render() {
    if (this.props.currentUser.roles.contractor || this.props.currentUser.roles.post_production || this.props.currentUser.roles.sales_rep) {
      return "";
    } else {
      return (
        <>
          <div className="dashboardNewProject">
            <div className="newProjectGroup1">
              <div className="dashboardCategoryHeading">Start a New Project</div>
              <div className="dashboardCategorySubheading">You can completely customize and review associated costs before
                confirming your project.
              </div>
            </div>
            <div className="newProjectGrouping">
              <div className="newProjectDashboardDiv" onClick={() => this.props.history.push("/create-project")}>
                <div className="newProjectImage photography"/>
                <div className="newProjectDashboardHeading">New Photography Project</div>
                <div className="newProjectDashboardHeadingDescription">Photography, Videos, Drones, Floor Plans</div>
              </div>
              <div className="newProjectDashboardDiv virtualSuiteDashboardImage"
                   onClick={() => this.setState({ vsModalOpen: true })}>
                <div className="newProjectImage virtualStaging"/>
                <div className="newProjectDashboardHeading">New Virtual Staging Order</div>
                <div className="newProjectDashboardHeadingDescription">Virtual Staging, Sky & View Replacement, Object
                  Removal
                </div>
              </div>
            </div>
          </div>
          {this.state.vsModalOpen && (
            <DashboardVirtualStagingModal
              currentUser={this.props.currentUser}
              onClose={() => this.setState({ vsModalOpen: false })}
            />
          )}
        </>
      );
    }
  }
}

export default withRouter(NewProjectsDashboard)